import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class MultiUserNameDisplayInfo {
    @Type(() => UserNameDisplayResultDto)
    users: Array<UserNameDisplayResultDto>;

    communityId: number;
    title: string;
}
